import { MotifButton } from "@ey-xd/motif-react";
import { Link, useNavigate } from "react-router-dom";
import { havingDeletePermission, havingEditPermission } from "@/utility/common";
import { GetCommonDeleteImgButton } from "@/components/Images/CommonImages";

export const useCustomCellRenderers = ({
  setShowDeleteClassPopup,
  setDistributionData,
  Distribution,
  duplicateBtnLabel,
}: {
  setDistributionData: (data: any) => void;
  setShowDeleteClassPopup: (value: boolean) => void;
  Distribution:string[],
  duplicateBtnLabel:string,
}) => {
  const nav=useNavigate();
  const caseRenderers = {
    distributionName: function (params: any) {
      return (
        <>
          {
            <Link
              to={`/case/${params.data.caseId}/distribution/${params.data.id}`}
            >
              <span className="text-bold-underline">{params.data.name}</span>
            </Link>
          }
        </>
      );
    },
    actionCellRenderers: function (param: any) {
      return (
        <>
          {havingEditPermission(Distribution) && param.data.isAllowToReplicate === true && 
            <div style={{paddingRight:"2px"}}>
              <MotifButton style={{height:"2.2rem"}} onClick={()=>nav(`/case/${param.data.caseId}/duplicate-distribution/${param.data.id}/create`)} size="small" type="button" variant="secondary">
                {duplicateBtnLabel}
              </MotifButton></div>}
        
          {havingDeletePermission(Distribution) && 
          <GetCommonDeleteImgButton  onClick={() => {
            setDistributionData(param.data);
            setShowDeleteClassPopup(true);
          }}></GetCommonDeleteImgButton>
          // <div className="motif-col-lg-4">
          //   <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
          //   <MotifButton
          //     size="small"
          //     variant={DELETE_IMG_VARIANT}
          //     type="button"
          //     onClick={() => {
          //       setDistributionData(param.data);
          //       setShowDeleteClassPopup(true);
          //     }}
          //   >
          //   {getCommonDeleteImg()}
          //   </MotifButton>
          //   </CommonTooltipWrapper>
          // </div>
          }
        </>
      );
    },
  };
  return caseRenderers;
};
